import moment from "moment";

/*
  Hook to get the first weekday in 30 days.
*/
export function useDefaultDate() {
  const defaultDate = moment().add(30, "days");
  if (defaultDate.day() === 6) {
    defaultDate.add(2, "days");
  } else if (defaultDate.day() === 7) {
    defaultDate.add(1, "day");
  }

  return defaultDate.toDate();
}

export function useDetectIosDevice() {
  const ua = navigator.userAgent;

  if (/iPhone|iPod|iPad|Mac/.test(ua)) {
    return true;
  }

  return false;
}